import { Component, Inject, Input, LOCALE_ID } from "@angular/core";
import { CommonModule, DOCUMENT } from "@angular/common";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-locale-picker",
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: "./locale-picker.component.html",
  styleUrl: "./locale-picker.component.css",
})
export class LocalePickerComponent {
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    @Inject(DOCUMENT) private document: Document,
    private translateService: TranslateService,
  ) {}
  @Input()
  type: "blue" | "white" | "yellow" = "white";

  public switchLang(): void {
    // Get current language
    const currentLang = this.translateService.currentLang ||
      this.translateService.getDefaultLang();

    // Switch to the opposite language
    const targetLang = currentLang === "nl" ? "en" : "nl";

    // Use TranslateService to switch language
    this.translateService.use(targetLang);
  }
}
